const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// ===============================
// Scroll Reveal Animation
// ===============================

function onIntersection(entries, observer) {
  entries.forEach((entry, index) => {
    const elementTarget = entry.target;

    if (entry.isIntersecting) {
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);

        if (elementTarget.hasAttribute('data-cascade')) {
          elementTarget.style.setProperty('--animation-order', index);
        }
      }

      observer.unobserve(elementTarget);

    } else {
      elementTarget.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      elementTarget.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = [
    ...rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  ];

  if (!animationTriggerElements.length) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -15% 0px',
    threshold: 0.1
  });

  animationTriggerElements.forEach((element) => observer.observe(element));
}

// ===============================
// Zoom Animation
// ===============================

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    return 0;
  }

  if (elementPositionY + elementHeight < scrollY) {
    return 100;
  }

  const distance = scrollY + viewportHeight - elementPositionY;
  const percentage = distance / ((viewportHeight + elementHeight) / 100);

  return Math.max(0, Math.min(100, Math.round(percentage)));
}

function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = [
    ...document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME)
  ];

  if (!animationTriggerElements.length) return;

  const scaleAmount = 0.2 / 100;

  const visibleElements = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visibleElements.add(entry.target);
        } else {
          visibleElements.delete(entry.target);
        }
      });
    },
    {
      threshold: 0.1
    }
  );

  animationTriggerElements.forEach((element) => {
    observer.observe(element);

    element.style.setProperty(
      '--zoom-in-ratio',
      1 + scaleAmount * percentageSeen(element)
    );
  });

  window.addEventListener(
    'scroll',
    throttle(() => {
      visibleElements.forEach((element) => {
        element.style.setProperty(
          '--zoom-in-ratio',
          1 + scaleAmount * percentageSeen(element)
        );
      });
    }),
    {
      passive: true
    }
  );
}

// ===============================
// Initialize
// ===============================

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

// ===============================
// Shopify Theme Editor
// ===============================

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeScrollAnimationTrigger(event.target, true);
  });

  document.addEventListener('shopify:section:reorder', () => {
    initializeScrollAnimationTrigger(document, true);
  });
}